import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CountDownService } from 'src/app/core/common/countdowntimer/countdowntimer-service';
import { CountDownModule } from 'src/app/core/common/countdowntimer/countdowntimer.module';
import { KeyboardService } from 'src/app/core/common/keyboard/keyboard.service';
import { NumpadModule } from 'src/app/core/common/numpad/numpad.module';
import { ConfirmFeeComponent } from '../[module]/confirm-fee/confirm-fee.component';
import { SetamountComponent } from '../[module]/setamount/setamount.component';
import { WithdrawcustomComponent } from './custom-amount/withdrawcustom.component';
import { DepositConfirmationComponent } from './deposit-confirmation/deposit-confirmation.component';
import { CardComponent } from './scan/card/card.component';
import { CardDepositComponent } from './scan/deposit/card.component';
import { WithdrawconfirmationComponent } from './withdrawconfirmation/withdrawconfirmation.component';
import { MobileComponent } from './mobile/mobile.component';
import { DepositComponent } from './deposit/deposit.component';
import { WithdrawComponent } from './withdraw/withdraw.component';
import { EnterAmountComponent } from './enter-amount/enter-amount.component';


@NgModule({
  declarations: [
    ConfirmFeeComponent,
    SetamountComponent,
    WithdrawconfirmationComponent,
    CardComponent,
    WithdrawcustomComponent,
    CardDepositComponent,
    DepositConfirmationComponent,
    MobileComponent,
    DepositComponent,
    WithdrawComponent,
    EnterAmountComponent
  ],
  imports: [
    CommonModule,
    NumpadModule,
    CountDownModule
  ],
  exports: [],
  providers: [CountDownService]
})
export class SharedModule { }
